import styled from 'styled-components';

export const StyledSortImagesActivity = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;

  .activity-image {
    text-align: center;
    position: relative;
    height: 100%;
    width: 100%;
    border-radius: 20px;
    overflow: hidden;
  }
`;
